import { useLocation, useNavigate } from "react-router-dom";

import { ReactComponent as ArrowIcon} from "../../../../assets/images/icons/arrow.svg";

import './back-btn.css';

export const BackButton = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname === '/search' || location.pathname.includes('/product/') ? "/" : -1;

    const goBack = () => navigate(path);

    return (
        <div className="col d-flex align-items-center back-btn" onClick={goBack}>
            <ArrowIcon fill={`white`}/>
            <span>Назад</span>
        </div>
    )
}